/**
 * reflects the api key access state on server.
 * REFUSED is reserved by the contract and is never returned today; no action is attached to it.
 */
export enum ApiKeyAccessState {
    NOT_REQUESTED = 'NOT_REQUESTED',
    PENDING = 'PENDING',
    GRANTED = 'GRANTED',
    WITHDRAWN = 'WITHDRAWN',
    REFUSED = 'REFUSED'
}
